module.exports = __webpack_public_path__ + "img/zhgc.5bda69cb.png";